"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const drg = {
    name: 'drg',
    tableType: 'dim',
    grain: [
        'drg',
        'year::key',
        '::key',
    ],
    tableGrain: [
        '!drg',
        'year_key',
    ],
    foreignKeys: [],
};
const icd = {
    name: 'icd-codes',
    tableType: 'dim',
    grain: [
        'icd_code',
        'year::key',
        '::key',
    ],
    tableGrain: [
        '!icd-codes',
        'year_key',
        'type',
    ],
    foreignKeys: [],
};
const hospitalDRGVolumeCharges = {
    name: 'hospital-drg-volume-and-charges',
    tableType: 'fact',
    grain: [
        'drg::key',
        'facility::key',
        'year::key',
    ],
    claimsColumns: [
        'count_of_claims',
    ],
    tableGrain: [
        '!facility',
        '!drg',
        'year_key',
    ],
    foreignKeys: [
        'facility::id',
        'facility::key',
        'drg::key',
    ]
};
const hospitalICDVolumeCharges = {
    name: 'hospital-icd-volume-and-charges',
    tableType: 'fact',
    grain: [
        'icd-codes::key',
        'facility::key',
        'year',
        'month'
    ],
    claimsColumns: [
        'count_of_claims',
    ],
    tableGrain: [
        '!icd-codes',
        'year',
        'month',
        '!facility',
    ],
    foreignKeys: [
        'facility::key',
        'facility::id',
        'icd-codes::key',
    ],
};
const hospitalICDVolumeChargesYearly = {
    name: 'hospital-icd-volume-and-charges-yearly',
    tableType: 'fact',
    grain: [
        'icd-codes::key',
        'facility::key',
        'year::key'
    ],
    claimsColumns: [
        'count_of_claims',
    ],
    tableGrain: [
        '!icd-codes',
        'year_key',
        '!facility',
    ],
    foreignKeys: [
        'facility::key',
        'facility::id',
        'icd-codes::key',
    ],
};
exports.default = [
    drg,
    icd,
    hospitalDRGVolumeCharges,
    hospitalICDVolumeCharges,
    hospitalICDVolumeChargesYearly
];
